import React from 'react'

const MenuContext = React.createContext({
  isOpen: false
})

export default MenuContext
